import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex: 1;
	justify-content: center;
`;
